import { createApp } from 'vue';
import VueGtag from 'vue-gtag';

import App from './App.vue';
import { Config } from './cfg';
import { Requester } from './requester';
// import './registerServiceWorker';
import router from './router';

let cfg: Config;
if (import.meta.env.PROD) {
  cfg = new Config('https://rpgroot.com');
} else {
  cfg = new Config('http://localhost:3000');
}
Requester.initialize(cfg);

createApp(App)
  .use(router)
  .use(
    VueGtag,
    {
      config: { id: 'G-SY6S58FT47' }
    },
    router
  )
  .mount('#app');
